import React, { FC } from 'react'
import { UseFormRegisterReturn } from 'react-hook-form'

interface DateInputProps {
  register: UseFormRegisterReturn
  min?: string
  max?: string
  width?: number | string
  className?: string
}

export const DateInput: FC<DateInputProps> = ({
  register,
  min,
  max,
  width = 280,
  className = '',
}) => {
  return (
    <input
      type="date"
      min={min}
      max={max}
      className={`px-3 py-2 border border-main-bordergray rounded-md focus:outline-none focus:border-2 focus:border-main-green ${className || 'w-full'}`}
      style={className && className.includes('w-') ? {} : { width }}
      {...register}
    />
  )
}
